import { createBrowserClient } from '@supabase/ssr';
import { SupabaseClient } from '@supabase/supabase-js';
import { createContext, PropsWithChildren, useContext } from 'react';

const SupabaseContext = createContext<SupabaseClient | undefined>(undefined);

interface SupabaseProviderProps extends PropsWithChildren {
  supabaseUrl: string;
  supabaseAnonKey: string;
}

export function SupabaseProvider({
  supabaseUrl,
  supabaseAnonKey,
  children,
}: SupabaseProviderProps) {
  const supabase = createBrowserClient(supabaseUrl, supabaseAnonKey);

  return (
    <SupabaseContext.Provider value={supabase}>
      {children}
    </SupabaseContext.Provider>
  );
}

export function useSupabase() {
  const context = useContext(SupabaseContext);
  if (!context)
    throw new Error('useUser must be used within an SupabaseProvider');
  return context;
}
